import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { warehouseBreakdown } from 'src/app/models/common.model';
import { LogisticService } from 'src/app/modules/logistic/logistic.service';

@Component({
  selector: 'app-warehouses-tooltip',
  templateUrl: './warehouses-tooltip.component.html',
  styleUrls: ['./warehouses-tooltip.component.scss']
})
export class WarehousesTooltipComponent implements OnInit,OnDestroy {
  warehouseList: warehouseBreakdown;
  reserved:number=0;
  private destroy$ = new Subject<void>();
  breakDown:any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<WarehousesTooltipComponent>,
    private logisticService:LogisticService,
    private snackbar:MatSnackBar
  ) {}


  ngOnInit(): void {
    if(!this.data?.IsPurchasedVelocity && !this.data?.accountSkuId && !this.data.isBillingBrackDown){
      this.logisticService.ProductWarehouseDetails(this.data).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res:any) => {
          this.warehouseList = res.warehouses || [];
          this.reserved=res.reserved;
        },
       error: (err) => {
        this.snackbar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: err.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
       }
     });
    }else if(this.data?.accountSkuId){
      this.getReplanishWareHouseDetails();
    }else{
      this.breakDown = this.data.billingBreakDown
    } 
  }

  getReplanishWareHouseDetails(){
    this.logisticService.ReplanishWarehouseSummary(this.data.accountSkuId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.warehouseList = res.warehouses;
        this.reserved=res.reserved;
      }, 
     error: (err) => {
      this.snackbar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
